import { DEFAULT_STATE, explorerFromParams, type AnalyticsResult, type ChartModel, type ExplorerState, type Metric } from './data.ts';

/** Only visible cockpit filters are accepted; an explorer URL cannot silently restrict a KPI. */
export function cockpitState(params: URLSearchParams): ExplorerState {
  const read = explorerFromParams(params);
  return { ...DEFAULT_STATE, preset: read.preset, from: read.from, to: read.to, compare: params.has('comparer') ? read.compare : 'PREVIOUS_PERIOD',
    currencyMode: read.currencyMode, filters: { ...DEFAULT_STATE.filters, entity_ids: read.filters.entity_ids.slice(0, 1) } };
}

/** Values remain exact decimals; conversion to number is exclusively for SVG geometry. */
export function cockpitTrend(result: AnalyticsResult, metrics: Metric[], currency: string | null, label: (metric: Metric) => string): ChartModel {
  const periods: string[] = [];
  const end = result.query.to.slice(0, 7);
  const cursor = new Date(`${result.query.from.slice(0, 7)}-01T00:00:00Z`);
  while (cursor.toISOString().slice(0, 7) <= end && periods.length < 25) {
    periods.push(cursor.toISOString().slice(0, 10));
    cursor.setUTCMonth(cursor.getUTCMonth() + 1);
  }
  const rows = new Map(result.rows.filter((row) => row.period !== null && !row.is_other).map((row) => [row.period!, row]));
  return { kind: 'line', categories: periods, hidden: 0,
    series: metrics.map((metric) => {
      const raw = periods.map((period) => rows.get(period)?.values.find((value) => value.metric === metric && value.currency === currency)?.value ?? null);
      return { key: metric, label: label(metric), isOther: false, raw, points: raw.map((value) => value === null ? null : Number(value)) };
    }),
  };
}
